import { Global as GlobalStyles, css } from '@emotion/core'
import React from 'react'
import { Provider } from 'react-redux'

import { useAppAuth } from 'packages/auth'
import {
  Loader,
  SentryErrorBoundary,
  ServiceWorkerWrapper,
} from 'packages/common'
import { colors } from 'packages/styles'

import { register as registerSW } from '../../serviceWorker'
import {
  AppContextWrapper,
  RefreshOnFocus,
  FieldAppContainer,
  UpdateNotifier,
} from './components'
import { FIELD_APP_CONTAINER_ID } from './FieldApp.constants'
import { FieldAppAuthContainer } from './FieldAppAuth.container'
import { initI18n } from './i18n'
import fieldappStore from './store/store'

import styles from './FieldApp.module.scss'

const globalStyles = css`
  body {
    background-color: ${colors.midnight4};
  }
`

const {
  REACT_APP_AUTH_BASE_URL: AUTH_URL = '',
  REACT_APP_AUTH_TOKEN_URL: TOKEN_URL = '',
  REACT_APP_AUTH_CLIENT_ID_FIELDAPP: AUTH_CLIENT_ID = '',
} = process.env

const FieldApp: React.FC = () => {
  const { authState, onAppAuthInitialized } = useAppAuth()

  const handleAuthInitialized = React.useCallback(
    async (initialUrl?: string) => {
      await initI18n()
      await onAppAuthInitialized(initialUrl)
    },
    [onAppAuthInitialized],
  )

  return (
    <SentryErrorBoundary boundary={'fieldapp-root'}>
      <Provider store={fieldappStore}>
        <GlobalStyles styles={globalStyles} />
        <FieldAppAuthContainer
          authClientId={AUTH_CLIENT_ID}
          authUrl={AUTH_URL}
          onAuthInitialized={handleAuthInitialized}
          tokenUrl={TOKEN_URL}
        />
        <RefreshOnFocus />

        {!authState.loaded ? (
          <Loader />
        ) : (
          <AppContextWrapper>
            <div
              className={styles.fieldAppViewWrapper}
              id={FIELD_APP_CONTAINER_ID}
            >
              <ServiceWorkerWrapper
                registerSW={registerSW}
                updateNotifier={<UpdateNotifier />}
              />

              <FieldAppContainer initialUrl={authState.initialUrl} />
            </div>
          </AppContextWrapper>
        )}
      </Provider>
    </SentryErrorBoundary>
  )
}

export default FieldApp
